import { render, staticRenderFns } from "./ContactInfoForm.vue?vue&type=template&id=6c188eb1"
import script from "./ContactInfoForm.vue?vue&type=script&lang=ts"
export * from "./ContactInfoForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports